module.exports = __webpack_public_path__ + "img/sport-crown.png";